const SET_LOADING = (state, status) => {
  state.loading = status
}

const SET_BUNDLES = (state, bundles) => {
  state.bundles = bundles
}

const SET_BUNDLE = (state, bundle) => {
  state.bundle = bundle
}

const PUSH = (state, bundle) => {
  state.bundles.push(bundle)
}

const UPDATE = (state, data) => {
  const bundle = state.bundles.find(x => x.id === state.bundle.id)

  bundle.name = data.name
  bundle.dossier_nr = data.dossier_nr
  bundle.profile_nr = data.profile_nr
}

const REMOVE = (state, bundleId) => {
  state.bundles.splice([state.bundles.findIndex(x => x.id === bundleId)], 1)
}

const RESET = (state) => {
  state.bundle = null
}

export default {
  PUSH,
  RESET,
  UPDATE,
  REMOVE,
  SET_BUNDLE,
  SET_BUNDLES,
  SET_LOADING
}
